import { render, staticRenderFns } from "./AttemptConfirmSubmit.vue?vue&type=template&id=ef75e1d6&"
import script from "./AttemptConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./AttemptConfirmSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports